import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  key: 1,
  class: "h-full overflow-y-auto"
}
const _hoisted_2 = { class: "py-4 flex flex-row justify-start items-center border-b border-gray-lp-400" }
const _hoisted_3 = { class: "font-semibold text-20px mr-4 text-black-lp-200" }
const _hoisted_4 = {
  key: 1,
  class: "flex flex-row py-6 mb-6 h-full overflow-y-auto"
}
const _hoisted_5 = { class: "w-2/3 px-4 text-12px xxl:text-14px" }
const _hoisted_6 = { class: "py-3" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "ID Konfigurable", -1)
const _hoisted_8 = { class: "my-1 text-black-lp-300" }
const _hoisted_9 = { class: "py-3" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Nama Konfigurasi Biaya ", -1)
const _hoisted_11 = { class: "my-1 text-black-lp-300" }
const _hoisted_12 = { class: "py-3" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Deskripsi", -1)
const _hoisted_14 = { class: "my-1 text-black-lp-300 w-3/4" }
const _hoisted_15 = { class: "py-3" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Tipe Tambahan Biaya ", -1)
const _hoisted_17 = { class: "my-1 text-gray-lp-300 px-2 inline-flex capitalize bg-gray-lp-200 rounded" }
const _hoisted_18 = { class: "py-3" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Tambahan Biaya ", -1)
const _hoisted_20 = { class: "my-3 font-normal flex flex-wrap w-10/12 gap-3" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400" }
const _hoisted_23 = { class: "py-3" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Status Konfigurasi Biaya ", -1)
const _hoisted_25 = { class: "text-gray-lp-300 my-1" }
const _hoisted_26 = { class: "flex" }
const _hoisted_27 = { class: "py-3" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tanggal Dibuat", -1)
const _hoisted_29 = { class: "my-1 text-black-lp-300" }
const _hoisted_30 = { class: "text-gray-lp-500" }
const _hoisted_31 = { class: "py-3" }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Terakhir Diperbarui", -1)
const _hoisted_33 = { class: "my-1 text-black-lp-300" }
const _hoisted_34 = { class: "text-gray-lp-500" }
const _hoisted_35 = { class: "py-3 inline-flex" }
const _hoisted_36 = { class: "max-w-2xl" }
const _hoisted_37 = { class: "font-normal flex flex-wrap gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Chips = _resolveComponent("Chips")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
          key: 0,
          onBack: _ctx.goBack
        }, null, 8, ["onBack"]))
      : (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("img", {
              src: _imports_0,
              class: "w-5 mr-3 cursor-pointer",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
              alt: "back"
            }),
            _createVNode("div", _hoisted_3, _toDisplayString(_ctx.dataDetail.name), 1)
          ]),
          (_ctx.isError)
            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                key: 0,
                errorType: _ctx.errorCause,
                onTryAgain: _ctx.getDataDetail
              }, null, 8, ["errorType", "onTryAgain"]))
            : (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createVNode("div", _hoisted_8, _toDisplayString(_ctx.dataDetail.id), 1)
                  ]),
                  _createVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createVNode("div", _hoisted_11, _toDisplayString(_ctx.dataDetail.name), 1)
                  ]),
                  _createVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode("div", _hoisted_14, _toDisplayString(_ctx.dataDetail.description), 1)
                  ]),
                  _createVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createVNode("div", _hoisted_17, _toDisplayString(_ctx.mappingType), 1)
                  ]),
                  _createVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _withDirectives(_createVNode("div", { class: "my-1 text-black-lp-300 capitalize" }, _toDisplayString(_ctx.dataDetail.additionalCost) + "% ", 513), [
                      [_vShow, _ctx.dataDetail.type === 'percentage']
                    ]),
                    _withDirectives(_createVNode("div", { class: "my-1 text-black-lp-300 capitalize" }, _toDisplayString(_ctx.additionalCost), 513), [
                      [_vShow, 
              _ctx.dataDetail.type === 'volume-weight' ||
                _ctx.dataDetail.type === 'dimension'
            ]
                    ])
                  ]),
                  _createVNode(_component_DataWrapper, {
                    label: "Kota Penyedia Woodpacking",
                    class: "text-black-lp-300 capitalize mt-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode("div", _hoisted_20, [
                        (_ctx.dataDetail.woodpackingAvailableCities.length === 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_21, "-"))
                          : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.dataDetail.woodpackingAvailableCities?.slice(0, 10), (city, index) => {
                              return (_openBlock(), _createBlock("div", {
                                class: "flex-col",
                                key: index
                              }, [
                                _createVNode(_component_Chips, {
                                  label: city.cityName.toLowerCase() === 'semua' ? 'Semua': city.cityName?.toUpperCase()
                                }, null, 8, ["label"])
                              ]))
                            }), 128)),
                        (_ctx.dataDetail.woodpackingAvailableCities?.length > 10)
                          ? (_openBlock(), _createBlock("div", {
                              key: 2,
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modelDialog = true)),
                              class: "text-red-lp-100 font-medium cursor-pointer mb-4"
                            }, " Lihat Semua "))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("div", _hoisted_22, [
                  _createVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode("div", _hoisted_25, [
                      _createVNode("div", _hoisted_26, [
                        _createVNode("div", {
                          class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.dataDetail.status.toLowerCase() === 'active'
                      ? 'bg-green-lp-300'
                      : 'bg-red-lp-600'
                  } ${
                    _ctx.dataDetail.status.toLowerCase() === 'active'
                      ? 'text-green-lp-200'
                      : 'text-red-lp-500'
                  }`
                
                        }, [
                          _createVNode("span", null, _toDisplayString(_ctx.dataDetail.status.toLowerCase() === "active"
                      ? "Aktif"
                      : "Tidak Aktif"), 1)
                        ], 2)
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode("div", _hoisted_29, _toDisplayString(_ctx.createdAt), 1),
                    _createVNode("div", _hoisted_30, _toDisplayString(_ctx.createdBy), 1)
                  ]),
                  _createVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createVNode("div", _hoisted_33, _toDisplayString(_ctx.updateAt), 1),
                    _createVNode("div", _hoisted_34, _toDisplayString(_ctx.updateBy), 1)
                  ]),
                  _createVNode("div", _hoisted_35, [
                    _createVNode(_component_LpButton, {
                      title: "Ubah",
                      customClass: "w-full",
                      onClick: _ctx.goEdit,
                      outline: "",
                      textColor: "red-lp-100"
                    }, null, 8, ["onClick"])
                  ])
                ])
              ]))
        ])),
    _createVNode(_component_Dialog, {
      title: "Kota Penyedia Woodpacking",
      modelValue: _ctx.modelDialog,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.modelDialog = $event))
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_36, [
          _createVNode("div", _hoisted_37, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataDetail.woodpackingAvailableCities, (city, index) => {
              return (_openBlock(), _createBlock("div", {
                class: "flex-col",
                key: index
              }, [
                _createVNode(_component_Chips, {
                  label: city.cityName
                }, null, 8, ["label"])
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}